import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getInvRewardListRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
  pageNum: number; // 页码，从1开始 ,
  pageSize: number; //每页记录数，1-100
}

export interface InvRewardDataVO {
  rwdDate?: string; //日期  ,
  reward?: string; // 奖品描述 ,
}

interface getInvRewardListResponse extends BaseResponse {
  Data: InvRewardDataVO[];
}

/**
 * 获取邀请奖励详情列表
 * @param params
 * @returns
 */
export async function getInvRewardList(request: getInvRewardListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvRewardList');
  return DsbcApi.fetch<getInvRewardListResponse>(url, request, true, options);
}
